module.exports = __webpack_public_path__ + "img/3.70369d21.jpg";